console.log("VORYNEX Homepage V2 — script loaded");

(function () {
  // Theme toggle (persists choice, defaults to dark)
  // Guarded: this section doesn't embed its own header (the theme's
  // existing global header is used instead), so #themeToggle may not
  // exist on the page — never let a missing header element crash the
  // whole script.
  const themeToggle = document.getElementById('themeToggle');
  const savedTheme = localStorage.getItem('vpx-preview-theme') || 'dark';
  if (savedTheme === 'light') document.documentElement.setAttribute('data-theme', 'light');
  if (themeToggle) {
    themeToggle.addEventListener('click', () => {
      const isLight = document.documentElement.getAttribute('data-theme') === 'light';
      if (isLight) {
        document.documentElement.removeAttribute('data-theme');
        localStorage.setItem('vpx-preview-theme', 'dark');
      } else {
        document.documentElement.setAttribute('data-theme', 'light');
        localStorage.setItem('vpx-preview-theme', 'light');
      }
    });
  }

  // Mobile nav drawer — same guard, since #hamburgerBtn/#mobileNav
  // also live in the (not embedded) custom header.
  const hamburgerBtn = document.getElementById('hamburgerBtn');
  const mobileNav = document.getElementById('mobileNav');
  const mobileNavOverlay = document.getElementById('mobileNavOverlay');
  if (hamburgerBtn && mobileNav && mobileNavOverlay) {
    function toggleMobileNav() {
      hamburgerBtn.classList.toggle('open');
      mobileNav.classList.toggle('open');
      mobileNavOverlay.classList.toggle('open');
    }
    hamburgerBtn.addEventListener('click', toggleMobileNav);
    mobileNavOverlay.addEventListener('click', toggleMobileNav);
  }

  // Header scroll state — guarded the same way.
  const header = document.getElementById('mainHeader');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    });
  }

  // Hero focal-point video — plays exactly once, then holds on its last
  // frame. Deliberately NOT wired to loop, restart, or reopen on scroll:
  // this hero already removed four competing infinite-loop animations
  // (breathing glow, live-status pulse, particle field, scroll-cue pulse),
  // and a repeating video would reopen that exact problem. The `loop`
  // attribute is never set in the markup, so once playback ends the
  // browser's own native behavior is to hold the final frame — no JS
  // needed for that part.
  const heroMedia = document.querySelector('[data-vpx-hero-media]');
  if (heroMedia) {
    const heroVideo = heroMedia.querySelector('.hero-media__video');
    const reduceMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Guards against this whole block ever running twice on the same
    // element. Found 2026-09-10: the network log showed the mobile clip
    // fetched 6 times in a row, 4 of them net::ERR_ABORTED — each fresh
    // .load() call aborts whatever fetch the previous one had in flight.
    // Whatever the exact re-entrancy trigger (Shopify's section morphing
    // re-runs section scripts on re-render; this file had no init guard
    // anywhere), this makes a second pass through this block a no-op
    // instead of a second competing download of a 1MB file.
    if (heroVideo && heroVideo.dataset.vpxInit !== '1') {
      heroVideo.dataset.vpxInit = '1';
      heroVideo.muted = true;

      // What plays where. Phones get a short clip if one is configured,
      // because clip LENGTH is what decides weight — not resolution, and not
      // how much of it we choose to play. Measured: with playback capped at
      // 6s, Chrome had still buffered 27 of the video's 31 seconds.
      //
      // 720p (`medium`) is desktop's safe default: full 1080p measured at
      // 16.9MB against 10.6MB — +62% of a file every desktop visitor pulls in
      // the background. The poster keeps it off the LCP path either way, but
      // those bytes still compete for bandwidth and decode time with ~14s of
      // third-party app script already on the page — 1080p for every desktop
      // visitor got the live site reported dragging.
      //
      // So 1080p is now scoped to where the softness actually shows and the
      // pipe can take it: viewports >=1440px (where the 1280x720 frame is
      // stretched hardest) or any desktop-width screen at 2x+ pixel density
      // (Retina-class — the same CSS width needs real source pixels to look
      // sharp). Both drop back to 720p if the connection looks weak, so a
      // big high-DPI screen on bad wifi still gets the lighter file instead
      // of reopening the dragging complaint.
      const conn = navigator.connection || {};
      const wantsLightPage =
        conn.saveData === true || /(^|-)2g$/.test(conn.effectiveType || '');
      const isSlowConnection = wantsLightPage || conn.effectiveType === '3g';

      const full = heroVideo.dataset.vpxHeroSrc;
      const medium = heroVideo.dataset.vpxHeroSrcMedium || full;
      const small = heroVideo.dataset.vpxHeroSrcSmall || full;
      const mobileClip = heroVideo.dataset.vpxHeroSrcMobile;
      const desktop = window.matchMedia('(min-width: 750px)').matches;
      const wantsSharp = desktop && !isSlowConnection &&
        window.matchMedia('(min-width: 1440px), (min-resolution: 2dppx)').matches;

      // Phones: a purpose-made short cut if one has been supplied, otherwise
      // the same hero footage at its lowest transcode. Never a different clip
      // — the showcase videos carry their own burnt-in product titles, which
      // have no business sitting under the hero headline.
      const chosen = !desktop ? (mobileClip || small) : (wantsSharp ? full : medium);
      const segment = parseFloat(heroVideo.dataset.vpxHeroSegment) || 0;

      // The markup now server-renders a <source src="hv_mobile"> so the
      // browser's preload scanner can queue the fetch while still parsing
      // HTML, well before this script runs — see the Liquid comment next
      // to it. This just re-points that element at the right quality
      // instead of building one from nothing; only the no-source fallback
      // (an older cached page shell) still creates one.
      let source = heroVideo.querySelector('source');

      if (chosen && !wantsLightPage && !reduceMotion) {
        if (!source) {
          source = document.createElement('source');
          source.type = 'video/mp4';
          heroVideo.appendChild(source);
        }

        // Compare resolved URLs: the attribute is protocol-relative, the
        // property is absolute, so a plain string compare always "changed".
        if (source.src !== new URL(chosen, location.href).href) {
          source.src = chosen;
          heroVideo.dataset.vpxSrcChanged = '1';
        }

        // The 720p URL is derived from the 1080p filename, so if Shopify ever
        // renames its transcodes the derived URL 404s. Fall back to the
        // original rather than leaving a hero that never plays. Only on
        // desktop — a phone falling back to the 31s file is the exact thing
        // this is here to prevent.
        source.addEventListener('error', function onErr() {
          if (desktop && source.src !== full) {
            source.src = full;
            heroVideo.load();
            const p = heroVideo.play();
            if (p && typeof p.catch === 'function') p.catch(() => {});
          }
        });
        // Loop a short segment instead of the whole clip. `loop` alone would
        // play all 31 seconds and pull the entire file down.
        if (segment > 0) {
          heroVideo.removeAttribute('loop');
          heroVideo.addEventListener('timeupdate', () => {
            if (heroVideo.currentTime >= segment) heroVideo.currentTime = 0;
          });
        }
      } else if (source) {
        // Data-saver / 2G / reduced-motion: the server-rendered <source>
        // never actually downloaded anything (preload="none" governs the
        // real fetch, not the scanner seeing the tag), but strip it anyway
        // so nothing can trigger a later fetch — matches the old
        // never-attached behaviour for these visitors exactly.
        source.remove();
      }

      // `is-ready` fades the video in over the always-visible poster <img>
      // underneath (see that element's own comment) — the poster is what
      // actually satisfies LCP now, on both branches below, so this fade
      // is purely cosmetic timing, never a paint-blocking gate.
      if (reduceMotion || !heroVideo.querySelector('source')) {
        // Never call play(). Either reduced motion is on, or no source was
        // attached at all — in both cases the poster is the hero and stays put.
        heroVideo.classList.add('is-ready');
      } else {
        // play() is called straight away, not on `loadeddata`. iOS Safari
        // downloads no media data until play() is called, so `loadeddata`
        // never fired there and the hero stayed on the poster on every
        // iPhone (reported 2026-10-06). The video fades in on `playing`,
        // i.e. once frames are actually on screen, on every platform.
        //
        // Started after the page's `load` event (or 4s at most), so the clip
        // does not compete with the poster, the LCP image, for bandwidth.
        const tryPlay = () => {
          const p = heroVideo.play();
          if (p && typeof p.catch === 'function') {
            // Muted autoplay can still be refused (iOS Low Power Mode). The
            // poster stays; the first touch anywhere is a user gesture that
            // allows play(), so try once more then.
            p.catch(() => {
              window.addEventListener('touchstart', () => {
                const p2 = heroVideo.play();
                if (p2 && typeof p2.catch === 'function') p2.catch(() => {});
              }, { once: true, passive: true });
            });
          }
        };
        heroVideo.addEventListener('playing', () => heroVideo.classList.add('is-ready'), { once: true });

        let started = false;
        const start = () => {
          if (started) return;
          started = true;
          // load() only when the source was swapped (desktop). On phones the
          // server-rendered source is already the right one, and load() on
          // top of play() aborted and restarted the download (measured: 3
          // requests for the clip, 2 of them ERR_ABORTED).
          if (heroVideo.dataset.vpxSrcChanged === '1') heroVideo.load();
          heroVideo.preload = 'auto';
          tryPlay();
        };
        if (document.readyState === 'complete') start();
        else {
          window.addEventListener('load', start, { once: true });
          setTimeout(start, 4000);
        }
      }
    }
  }

  // Scroll reveal — content is visible by default (see CSS); JS only
  // ADDS the hidden "pre-reveal" state right before observing, so a
  // JS failure or a non-firing observer (e.g. inside some editor
  // iframes) never leaves content permanently invisible.
  // 2026-11-03 (improve-animations): only content BELOW the first screen is hidden, so nothing already visible
  // blinks out and back in. The old safety net revealed every element at 1.2 s, which meant the scroll reveal never
  // actually played for anything further down. Now the net only catches elements that are on screen but were
  // missed by the observer (checked every 1.5 s while any are pending). Off in the theme editor and for reduced motion.
  const revealEls = document.querySelectorAll('.reveal');
  const revealOff = (window.Shopify && Shopify.designMode) ||
    (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  if (window.IntersectionObserver && !revealOff) {
    const pending = new Set();
    const show = (el) => { el.classList.add('visible'); pending.delete(el); };
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          setTimeout(() => show(entry.target), i * 60);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    revealEls.forEach(el => {
      if (el.getBoundingClientRect().top < window.innerHeight) return; // already on screen: leave it visible
      el.classList.add('pre-reveal');
      pending.add(el);
      io.observe(el);
    });

    if (pending.size) {
      const net = setInterval(() => {
        pending.forEach(el => { if (el.getBoundingClientRect().top < window.innerHeight) { io.unobserve(el); show(el); } });
        if (!pending.size) clearInterval(net);
      }, 1500);
    }
  }
  // If IntersectionObserver isn't supported at all, elements simply
  // stay in their default visible CSS state — nothing to do here.

  // Quality Assurance certificate — staggered checkmarks + scan line
  const qaCert = document.getElementById('qaCert');
  const qaRows = qaCert.querySelectorAll('.qa-cert-row');
  const qaIo = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        qaRows.forEach((row, i) => {
          setTimeout(() => row.classList.add('visible'), i * 180);
        });
        setTimeout(() => qaCert.classList.add('scan'), qaRows.length * 180 + 300);
        qaIo.unobserve(entry.target);
      }
    });
  }, { threshold: 0.35 });
  qaIo.observe(qaCert);

  // EKG draw-on-scroll
  const ekgPath = document.getElementById('ekgPath');
  const ekgIo = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        ekgPath.classList.add('animate');
        ekgIo.unobserve(entry.target);
      }
    });
  }, { threshold: 0.4 });
  ekgIo.observe(ekgPath);

  // Hero particle field removed (LNDR direction, Phase: hero redesign) —
  // it was an infinite, un-gated requestAnimationFrame loop with no
  // prefers-reduced-motion check of its own, competing with the drafting
  // mesh and the headline accent for attention. The <canvas id="particles">
  // element it targeted no longer exists in the hero markup.

  // Reduced motion is handled in CSS now (see the global rule at the top of
  // vorynex-homepage-v2.css). This used to be a querySelectorAll('*') that
  // walked every node on the page and wrote an inline animation-duration onto
  // each one — a full-document style invalidation, paid by exactly the users
  // who are most likely to be on a machine that can't afford it. The CSS rule
  // costs nothing at runtime, and reaches ::before/::after and transitions,
  // which the inline-style version could never touch.
})();

(function () {

  /* =====================================================
     THE HUMAN ENGINE — self-contained module, no shared
     globals with the rest of the page.
     ===================================================== */
  // The homepage can show "Shop by routine" instead (2026-10-30); without the engine markup this module must
  // stop here, or getContext() on a missing canvas would throw and halt the rest of this file.
  if (!document.getElementById("flowCanvas")) return;
  const CHANNELS = {
    creatine:  { region: "region-muscles", target: { x: 0.5,  y: 0.27 }, pathway: "ATP-PC",   targetLabel: "MUSCLE",  dose: "5 G" },
    protein:   { region: "region-core",    target: { x: 0.5,  y: 0.40 }, pathway: "MPS",      targetLabel: "TISSUE",  dose: "25-30 G" },
    preworkout:{ region: "region-brain",   target: { x: 0.5,  y: 0.10 }, pathway: "T-MINUS 30", targetLabel: "PRE-TRAINING", dose: "1 SCOOP" },
    bones:     { region: "region-joints",  target: { x: 0.37, y: 0.72 }, pathway: "D3 + K2",  targetLabel: "BONES",   dose: "1 CAPSULE" }
  };

  // Readout labels in the visitor's language, set by the section (English above is the fallback).
  const readoutOverrides = window.VPX_ENGINE_READOUTS || {};
  Object.keys(readoutOverrides).forEach(function (key) {
    if (CHANNELS[key]) Object.assign(CHANNELS[key], readoutOverrides[key]);
  });

  let activeChannel = "creatine";
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setRegion(channelKey) {
    document.querySelectorAll(".region").forEach(r => r.classList.remove("lit"));
    const region = document.getElementById(CHANNELS[channelKey].region);
    if (region) region.classList.add("lit");
  }

  function typeInto(el, text) {
    if (reduceMotion) { el.innerHTML = text + '<span class="cursor"></span>'; return; }
    el.innerHTML = '<span class="cursor"></span>';
    let i = 0;
    const iv = setInterval(() => {
      i++;
      el.innerHTML = text.slice(0, i) + '<span class="cursor"></span>';
      if (i >= text.length) clearInterval(iv);
    }, 42);
  }

  function setReadout(channelKey) {
    const c = CHANNELS[channelKey];
    typeInto(document.getElementById("roPathway"), c.pathway);
    document.getElementById("roTarget").textContent = c.targetLabel;
    document.getElementById("roDose").textContent = c.dose;
  }

  document.querySelectorAll(".channel").forEach(ch => {
    ch.addEventListener("click", () => {
      const key = ch.getAttribute("data-channel");
      if (key === activeChannel) return;
      activeChannel = key;
      document.querySelectorAll(".channel").forEach(c => c.classList.remove("active"));
      ch.classList.add("active");
      setRegion(key);
      setReadout(key);
    });
  });

  const engineCanvas = document.getElementById("flowCanvas");
  const engineCtx = engineCanvas.getContext("2d");
  let engineW, engineH;

  function engineResize() {
    const rect = engineCanvas.parentElement.getBoundingClientRect();
    engineW = engineCanvas.width = rect.width * devicePixelRatio;
    engineH = engineCanvas.height = rect.height * devicePixelRatio;
    engineCanvas.style.width = rect.width + "px";
    engineCanvas.style.height = rect.height + "px";
  }
  engineResize();
  window.addEventListener("resize", engineResize);

  const PARTICLE_COUNT = reduceMotion ? 0 : 46;
  const engineParticles = [];

  function spawnParticle(initial) {
    const side = Math.random() < 0.5 ? "left" : "right";
    const t = CHANNELS[activeChannel].target;
    return {
      x: side === "left" ? -10 * devicePixelRatio : engineW + 10 * devicePixelRatio,
      y: (0.15 + Math.random() * 0.7) * engineH,
      cx: (side === "left" ? 0.22 : 0.78) * engineW + (Math.random() - 0.5) * 0.15 * engineW,
      cy: Math.random() * engineH,
      tx: t.x * engineW + (Math.random() - 0.5) * 0.07 * engineW,
      ty: t.y * engineH + (Math.random() - 0.5) * 0.05 * engineH,
      progress: initial ? Math.random() : 0,
      speed: 0.0022 + Math.random() * 0.0028,
      size: (0.8 + Math.random() * 1.6) * devicePixelRatio,
      alpha: 0.25 + Math.random() * 0.55
    };
  }

  for (let i = 0; i < PARTICLE_COUNT; i++) engineParticles.push(spawnParticle(true));

  function bezier(p, a, c, b) {
    const inv = 1 - p;
    return inv * inv * a + 2 * inv * p * c + p * p * b;
  }

  // The particle canvas used to be an unconditional, never-ending rAF loop:
  // it kept drawing 46 gradient-stroked trails at 60fps for the whole life of
  // the page, including while the section sat far below the fold and while the
  // tab was in the background. On a production mobile profile that measured
  // 6.7 seconds of main-thread time and was the single biggest contributor to
  // the page's 3.2s blocking time.
  //
  // The drawing code below is unchanged — this only decides WHEN it runs:
  // on screen, and only while the tab is actually being looked at. That also
  // brings this section in line with the rest of the redesign, where the
  // infinite loops were removed in favour of motion that starts on approach.
  let engineRaf = null;

  function engineStart() {
    if (engineRaf === null && !reduceMotion) engineTick();
  }

  function engineStop() {
    if (engineRaf !== null) {
      cancelAnimationFrame(engineRaf);
      engineRaf = null;
    }
  }

  function engineTick() {
    engineCtx.clearRect(0, 0, engineW, engineH);

    for (let i = 0; i < engineParticles.length; i++) {
      const pt = engineParticles[i];
      pt.progress += pt.speed;

      if (pt.progress >= 1) {
        engineParticles[i] = spawnParticle(false);
        continue;
      }

      const x = bezier(pt.progress, pt.x, pt.cx, pt.tx);
      const y = bezier(pt.progress, pt.y, pt.cy, pt.ty);

      let a = pt.alpha;
      if (pt.progress < 0.1) a *= pt.progress / 0.1;
      if (pt.progress > 0.85) a *= (1 - pt.progress) / 0.15;

      const trailX = bezier(Math.max(0, pt.progress - 0.03), pt.x, pt.cx, pt.tx);
      const trailY = bezier(Math.max(0, pt.progress - 0.03), pt.y, pt.cy, pt.ty);
      const grad = engineCtx.createLinearGradient(trailX, trailY, x, y);
      grad.addColorStop(0, "rgba(255,107,53,0)");
      grad.addColorStop(1, `rgba(255,138,92,${a})`);
      engineCtx.strokeStyle = grad;
      engineCtx.lineWidth = pt.size;
      engineCtx.lineCap = "round";
      engineCtx.beginPath();
      engineCtx.moveTo(trailX, trailY);
      engineCtx.lineTo(x, y);
      engineCtx.stroke();
    }

    engineRaf = requestAnimationFrame(engineTick);
  }

  // Only run while the canvas is on screen. rootMargin gives it a screen of
  // lead-in so it is already moving by the time it scrolls into view.
  if (!reduceMotion && window.IntersectionObserver) {
    const engineIo = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && document.visibilityState === 'visible') engineStart();
          else engineStop();
        });
      },
      { rootMargin: '100% 0px' }
    );
    engineIo.observe(engineCanvas);

    // A background tab still services rAF in some browsers, and there is no
    // reason to paint for nobody.
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        const r = engineCanvas.getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight * 2) engineStart();
      } else {
        engineStop();
      }
    });
  } else if (!reduceMotion) {
    // No IntersectionObserver: fall back to the previous always-on behaviour
    // rather than leaving the canvas blank.
    engineStart();
  }

  setRegion(activeChannel);

})();